import {
  Embed,
  Image,
  Member,
  Message,
  File as UploadedFile,
} from '@tribeplatform/gql-client/types'

export type ChatPreviewContext = 'navbar' | 'page'

export type ChatAttachment = {
  file?: File
  id: string
  uploadedFile?: UploadedFile | Image
  type: 'image' | 'file' | 'giphy'
}

export enum DraftMessageType {
  New = 'new',
  Edit = 'edit',
}

export type DraftMessage = {
  attachments?: ChatAttachment[]
  embeds?: Embed[]
  content?: string
} & (
  | {
      type: DraftMessageType.New
    }
  | {
      type: DraftMessageType.Edit
      originalMessage: Message
    }
)

export interface NewChatFormFields {
  name: string
  members?: Member[] | Member
  avatar: Image
}

export interface ComposerSubmitParams {
  giphyFiles?: File[]
  isSendingGiphy?: boolean
}
